'use client';

import React from 'react';

interface ProjectCTAProps {
  title?: string;
  buttonText?: string;
}

const fontWeights = {
  inter: { regular: 400, bold: 700 },
  lato: { bold: 700 },
};

const ProjectCTA = ({
  title = 'Craft your next digital masterpiece with our IT experts',
  buttonText = "Let's Discuss Your Project"
}: ProjectCTAProps) => {
  return (
    <section className="bg-white w-full">
      <div className="max-w-[1220px] mx-auto px-4 sm:px-6">
        <div className="bg-[#012A49] rounded-[15px] sm:rounded-[30px] p-4 sm:p-6 md:p-10 lg:p-12 flex flex-col md:flex-row items-center justify-between gap-6 sm:gap-8 shadow-xl relative overflow-hidden">
          <h2 className="text-white text-[20px] sm:text-[32px] lg:text-[40px] leading-tight max-w-[600px] text-center md:text-left"
            style={{ fontFamily: "Lato", fontWeight: fontWeights.lato.bold }}>
            {title}
          </h2>
          <button
            onClick={() => window.dispatchEvent(new CustomEvent("openContactPopup"))}
            className="whitespace-nowrap bg-[#005bb7] hover:bg-[#004a96] text-white px-4 sm:px-6 md:px-8 py-2 sm:py-3 md:py-4 rounded-lg text-[14px] sm:text-[16px] transition-all shadow-md"
            style={{ fontFamily: "Inter", fontWeight: fontWeights.inter.bold }}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProjectCTA;
